import React, { useEffect, useState } from 'react';
import { numberWithSpaces } from '../../../../utils';
import styles from '../styles/YourLoyaltyPoints.module.scss';

const YourLoyaltyPoints = () => {
  const [loyaltyProgramPoints, setLoyaltyProgramPoints] = useState<{
    appliedLoyaltyProgramPoints: number;
    appliedLoyaltyProgramPointsGlobal: number;
    loyaltyProgramPointsBalance: number;
    loyaltyProgramPointsGlobalBalance: number;
    companyName: string;
  } | null>(null);

  useEffect(() => {
    const loyaltyProgramPointsSessionStorage = sessionStorage.getItem(
      'loyaltyProgramPoints'
    );

    if (loyaltyProgramPointsSessionStorage) {
      setLoyaltyProgramPoints(JSON.parse(loyaltyProgramPointsSessionStorage));
    }
  }, []);

  const minusOrPlus = (number: number) =>
    number > 0 ? styles['plus'] : styles['minus'];

  if (
    !loyaltyProgramPoints?.appliedLoyaltyProgramPoints &&
    !loyaltyProgramPoints?.appliedLoyaltyProgramPointsGlobal &&
    !loyaltyProgramPoints?.loyaltyProgramPointsBalance &&
    !loyaltyProgramPoints?.loyaltyProgramPointsGlobalBalance
  ) {
    return null;
  }

  const {
    appliedLoyaltyProgramPoints,
    appliedLoyaltyProgramPointsGlobal,
    companyName,
    loyaltyProgramPointsBalance,
    loyaltyProgramPointsGlobalBalance,
  } = loyaltyProgramPoints;

  return (
    <div className={styles['container']}>
      <h6 className={styles['title']}>Twoje punkty lojalnościowe</h6>

      {!!appliedLoyaltyProgramPoints && (
        <div className={styles['wrapper']}>
          <div className={styles['flex']}>
            <svg
              fill="none"
              height="17"
              viewBox="0 0 16 17"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.47333 4.97346L7.33333 4.10679V11.8335C7.33333 12.0103 7.40357 12.1798 7.5286 12.3049C7.65362 12.4299 7.82319 12.5001 8 12.5001C8.17681 12.5001 8.34638 12.4299 8.4714 12.3049C8.59643 12.1798 8.66667 12.0103 8.66667 11.8335V4.10679L9.52667 4.97346C9.58864 5.03594 9.66238 5.08554 9.74362 5.11938C9.82486 5.15323 9.91199 5.17065 10 5.17065C10.088 5.17065 10.1751 5.15323 10.2564 5.11938C10.3376 5.08554 10.4114 5.03594 10.4733 4.97346C10.5358 4.91148 10.5854 4.83775 10.6193 4.75651C10.6531 4.67527 10.6705 4.58813 10.6705 4.50012C10.6705 4.41211 10.6531 4.32498 10.6193 4.24374C10.5854 4.1625 10.5358 4.08876 10.4733 4.02679L8.47333 2.02679C8.41136 1.9643 8.33762 1.91471 8.25638 1.88086C8.17515 1.84702 8.08801 1.82959 8 1.82959C7.91199 1.82959 7.82486 1.84702 7.74362 1.88086C7.66238 1.91471 7.58864 1.9643 7.52667 2.02679L5.52667 4.02679C5.40113 4.15232 5.33061 4.32259 5.33061 4.50012C5.33061 4.67766 5.40113 4.84792 5.52667 4.97346C5.6522 5.09899 5.82247 5.16952 6 5.16952C6.17753 5.16952 6.3478 5.09899 6.47333 4.97346V4.97346ZM12 6.50012H10.6667C10.4899 6.50012 10.3203 6.57036 10.1953 6.69538C10.0702 6.82041 10 6.98998 10 7.16679C10 7.3436 10.0702 7.51317 10.1953 7.63819C10.3203 7.76322 10.4899 7.83346 10.6667 7.83346H12C12.1768 7.83346 12.3464 7.90369 12.4714 8.02872C12.5964 8.15374 12.6667 8.32331 12.6667 8.50012V13.1668C12.6667 13.3436 12.5964 13.5132 12.4714 13.6382C12.3464 13.7632 12.1768 13.8335 12 13.8335H4C3.82319 13.8335 3.65362 13.7632 3.5286 13.6382C3.40357 13.5132 3.33333 13.3436 3.33333 13.1668V8.50012C3.33333 8.32331 3.40357 8.15374 3.5286 8.02872C3.65362 7.90369 3.82319 7.83346 4 7.83346H5.33333C5.51014 7.83346 5.67971 7.76322 5.80474 7.63819C5.92976 7.51317 6 7.3436 6 7.16679C6 6.98998 5.92976 6.82041 5.80474 6.69538C5.67971 6.57036 5.51014 6.50012 5.33333 6.50012H4C3.46957 6.50012 2.96086 6.71084 2.58579 7.08591C2.21071 7.46098 2 7.96969 2 8.50012V13.1668C2 13.6972 2.21071 14.2059 2.58579 14.581C2.96086 14.9561 3.46957 15.1668 4 15.1668H12C12.5304 15.1668 13.0391 14.9561 13.4142 14.581C13.7893 14.2059 14 13.6972 14 13.1668V8.50012C14 7.96969 13.7893 7.46098 13.4142 7.08591C13.0391 6.71084 12.5304 6.50012 12 6.50012Z"
                fill="#62748C"
              />
            </svg>

            <div>
              <h6>Skarbonka</h6>
              <p>{companyName}</p>
            </div>
          </div>
          <div
            className={`${styles['points']} ${minusOrPlus(
              appliedLoyaltyProgramPoints
            )}`}
          >
            {appliedLoyaltyProgramPoints > 0 && '+'}
            {numberWithSpaces(appliedLoyaltyProgramPoints)} <span>pkt</span>
          </div>
        </div>
      )}

      {appliedLoyaltyProgramPointsGlobal && (
        <div className={styles['wrapper']}>
          <div className={styles['flex']}>
            <svg
              fill="none"
              height="17"
              viewBox="0 0 16 17"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.47333 4.97346L7.33333 4.10679V11.8335C7.33333 12.0103 7.40357 12.1798 7.5286 12.3049C7.65362 12.4299 7.82319 12.5001 8 12.5001C8.17681 12.5001 8.34638 12.4299 8.4714 12.3049C8.59643 12.1798 8.66667 12.0103 8.66667 11.8335V4.10679L9.52667 4.97346C9.58864 5.03594 9.66238 5.08554 9.74362 5.11938C9.82486 5.15323 9.91199 5.17065 10 5.17065C10.088 5.17065 10.1751 5.15323 10.2564 5.11938C10.3376 5.08554 10.4114 5.03594 10.4733 4.97346C10.5358 4.91148 10.5854 4.83775 10.6193 4.75651C10.6531 4.67527 10.6705 4.58813 10.6705 4.50012C10.6705 4.41211 10.6531 4.32498 10.6193 4.24374C10.5854 4.1625 10.5358 4.08876 10.4733 4.02679L8.47333 2.02679C8.41136 1.9643 8.33762 1.91471 8.25638 1.88086C8.17515 1.84702 8.08801 1.82959 8 1.82959C7.91199 1.82959 7.82486 1.84702 7.74362 1.88086C7.66238 1.91471 7.58864 1.9643 7.52667 2.02679L5.52667 4.02679C5.40113 4.15232 5.33061 4.32259 5.33061 4.50012C5.33061 4.67766 5.40113 4.84792 5.52667 4.97346C5.6522 5.09899 5.82247 5.16952 6 5.16952C6.17753 5.16952 6.3478 5.09899 6.47333 4.97346V4.97346ZM12 6.50012H10.6667C10.4899 6.50012 10.3203 6.57036 10.1953 6.69538C10.0702 6.82041 10 6.98998 10 7.16679C10 7.3436 10.0702 7.51317 10.1953 7.63819C10.3203 7.76322 10.4899 7.83346 10.6667 7.83346H12C12.1768 7.83346 12.3464 7.90369 12.4714 8.02872C12.5964 8.15374 12.6667 8.32331 12.6667 8.50012V13.1668C12.6667 13.3436 12.5964 13.5132 12.4714 13.6382C12.3464 13.7632 12.1768 13.8335 12 13.8335H4C3.82319 13.8335 3.65362 13.7632 3.5286 13.6382C3.40357 13.5132 3.33333 13.3436 3.33333 13.1668V8.50012C3.33333 8.32331 3.40357 8.15374 3.5286 8.02872C3.65362 7.90369 3.82319 7.83346 4 7.83346H5.33333C5.51014 7.83346 5.67971 7.76322 5.80474 7.63819C5.92976 7.51317 6 7.3436 6 7.16679C6 6.98998 5.92976 6.82041 5.80474 6.69538C5.67971 6.57036 5.51014 6.50012 5.33333 6.50012H4C3.46957 6.50012 2.96086 6.71084 2.58579 7.08591C2.21071 7.46098 2 7.96969 2 8.50012V13.1668C2 13.6972 2.21071 14.2059 2.58579 14.581C2.96086 14.9561 3.46957 15.1668 4 15.1668H12C12.5304 15.1668 13.0391 14.9561 13.4142 14.581C13.7893 14.2059 14 13.6972 14 13.1668V8.50012C14 7.96969 13.7893 7.46098 13.4142 7.08591C13.0391 6.71084 12.5304 6.50012 12 6.50012Z"
                fill="#62748C"
              />
            </svg>

            <div>
              <h6>Punkty Dietly</h6>
              <p>Program lojalnościowy Dietly</p>
            </div>
          </div>
          <div
            className={`${styles['points']} ${minusOrPlus(
              appliedLoyaltyProgramPointsGlobal
            )}`}
          >
            {appliedLoyaltyProgramPointsGlobal > 0 && '+'}
            {numberWithSpaces(appliedLoyaltyProgramPointsGlobal)}{' '}
            <span>pkt</span>
          </div>
        </div>
      )}

      <div className={styles['divider']} />

      {loyaltyProgramPointsBalance && (
        <div className={styles['wrapper']}>
          <div className={styles['flex']}>
            <svg
              fill="none"
              height="17"
              viewBox="0 0 16 17"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.47333 4.97346L7.33333 4.10679V11.8335C7.33333 12.0103 7.40357 12.1798 7.5286 12.3049C7.65362 12.4299 7.82319 12.5001 8 12.5001C8.17681 12.5001 8.34638 12.4299 8.4714 12.3049C8.59643 12.1798 8.66667 12.0103 8.66667 11.8335V4.10679L9.52667 4.97346C9.58864 5.03594 9.66238 5.08554 9.74362 5.11938C9.82486 5.15323 9.91199 5.17065 10 5.17065C10.088 5.17065 10.1751 5.15323 10.2564 5.11938C10.3376 5.08554 10.4114 5.03594 10.4733 4.97346C10.5358 4.91148 10.5854 4.83775 10.6193 4.75651C10.6531 4.67527 10.6705 4.58813 10.6705 4.50012C10.6705 4.41211 10.6531 4.32498 10.6193 4.24374C10.5854 4.1625 10.5358 4.08876 10.4733 4.02679L8.47333 2.02679C8.41136 1.9643 8.33762 1.91471 8.25638 1.88086C8.17515 1.84702 8.08801 1.82959 8 1.82959C7.91199 1.82959 7.82486 1.84702 7.74362 1.88086C7.66238 1.91471 7.58864 1.9643 7.52667 2.02679L5.52667 4.02679C5.40113 4.15232 5.33061 4.32259 5.33061 4.50012C5.33061 4.67766 5.40113 4.84792 5.52667 4.97346C5.6522 5.09899 5.82247 5.16952 6 5.16952C6.17753 5.16952 6.3478 5.09899 6.47333 4.97346V4.97346ZM12 6.50012H10.6667C10.4899 6.50012 10.3203 6.57036 10.1953 6.69538C10.0702 6.82041 10 6.98998 10 7.16679C10 7.3436 10.0702 7.51317 10.1953 7.63819C10.3203 7.76322 10.4899 7.83346 10.6667 7.83346H12C12.1768 7.83346 12.3464 7.90369 12.4714 8.02872C12.5964 8.15374 12.6667 8.32331 12.6667 8.50012V13.1668C12.6667 13.3436 12.5964 13.5132 12.4714 13.6382C12.3464 13.7632 12.1768 13.8335 12 13.8335H4C3.82319 13.8335 3.65362 13.7632 3.5286 13.6382C3.40357 13.5132 3.33333 13.3436 3.33333 13.1668V8.50012C3.33333 8.32331 3.40357 8.15374 3.5286 8.02872C3.65362 7.90369 3.82319 7.83346 4 7.83346H5.33333C5.51014 7.83346 5.67971 7.76322 5.80474 7.63819C5.92976 7.51317 6 7.3436 6 7.16679C6 6.98998 5.92976 6.82041 5.80474 6.69538C5.67971 6.57036 5.51014 6.50012 5.33333 6.50012H4C3.46957 6.50012 2.96086 6.71084 2.58579 7.08591C2.21071 7.46098 2 7.96969 2 8.50012V13.1668C2 13.6972 2.21071 14.2059 2.58579 14.581C2.96086 14.9561 3.46957 15.1668 4 15.1668H12C12.5304 15.1668 13.0391 14.9561 13.4142 14.581C13.7893 14.2059 14 13.6972 14 13.1668V8.50012C14 7.96969 13.7893 7.46098 13.4142 7.08591C13.0391 6.71084 12.5304 6.50012 12 6.50012Z"
                fill="#62748C"
              />
            </svg>

            <div>
              <h5>Saldo</h5>
              <p>{companyName}</p>
            </div>
          </div>
          <div className={styles['points']}>
            {numberWithSpaces(loyaltyProgramPointsBalance)} <span>pkt</span>
          </div>
        </div>
      )}

      {loyaltyProgramPointsGlobalBalance && (
        <div className={styles['wrapper']}>
          <div className={styles['flex']}>
            <svg
              fill="none"
              height="17"
              viewBox="0 0 16 17"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.47333 4.97346L7.33333 4.10679V11.8335C7.33333 12.0103 7.40357 12.1798 7.5286 12.3049C7.65362 12.4299 7.82319 12.5001 8 12.5001C8.17681 12.5001 8.34638 12.4299 8.4714 12.3049C8.59643 12.1798 8.66667 12.0103 8.66667 11.8335V4.10679L9.52667 4.97346C9.58864 5.03594 9.66238 5.08554 9.74362 5.11938C9.82486 5.15323 9.91199 5.17065 10 5.17065C10.088 5.17065 10.1751 5.15323 10.2564 5.11938C10.3376 5.08554 10.4114 5.03594 10.4733 4.97346C10.5358 4.91148 10.5854 4.83775 10.6193 4.75651C10.6531 4.67527 10.6705 4.58813 10.6705 4.50012C10.6705 4.41211 10.6531 4.32498 10.6193 4.24374C10.5854 4.1625 10.5358 4.08876 10.4733 4.02679L8.47333 2.02679C8.41136 1.9643 8.33762 1.91471 8.25638 1.88086C8.17515 1.84702 8.08801 1.82959 8 1.82959C7.91199 1.82959 7.82486 1.84702 7.74362 1.88086C7.66238 1.91471 7.58864 1.9643 7.52667 2.02679L5.52667 4.02679C5.40113 4.15232 5.33061 4.32259 5.33061 4.50012C5.33061 4.67766 5.40113 4.84792 5.52667 4.97346C5.6522 5.09899 5.82247 5.16952 6 5.16952C6.17753 5.16952 6.3478 5.09899 6.47333 4.97346V4.97346ZM12 6.50012H10.6667C10.4899 6.50012 10.3203 6.57036 10.1953 6.69538C10.0702 6.82041 10 6.98998 10 7.16679C10 7.3436 10.0702 7.51317 10.1953 7.63819C10.3203 7.76322 10.4899 7.83346 10.6667 7.83346H12C12.1768 7.83346 12.3464 7.90369 12.4714 8.02872C12.5964 8.15374 12.6667 8.32331 12.6667 8.50012V13.1668C12.6667 13.3436 12.5964 13.5132 12.4714 13.6382C12.3464 13.7632 12.1768 13.8335 12 13.8335H4C3.82319 13.8335 3.65362 13.7632 3.5286 13.6382C3.40357 13.5132 3.33333 13.3436 3.33333 13.1668V8.50012C3.33333 8.32331 3.40357 8.15374 3.5286 8.02872C3.65362 7.90369 3.82319 7.83346 4 7.83346H5.33333C5.51014 7.83346 5.67971 7.76322 5.80474 7.63819C5.92976 7.51317 6 7.3436 6 7.16679C6 6.98998 5.92976 6.82041 5.80474 6.69538C5.67971 6.57036 5.51014 6.50012 5.33333 6.50012H4C3.46957 6.50012 2.96086 6.71084 2.58579 7.08591C2.21071 7.46098 2 7.96969 2 8.50012V13.1668C2 13.6972 2.21071 14.2059 2.58579 14.581C2.96086 14.9561 3.46957 15.1668 4 15.1668H12C12.5304 15.1668 13.0391 14.9561 13.4142 14.581C13.7893 14.2059 14 13.6972 14 13.1668V8.50012C14 7.96969 13.7893 7.46098 13.4142 7.08591C13.0391 6.71084 12.5304 6.50012 12 6.50012Z"
                fill="#62748C"
              />
            </svg>

            <div>
              <h5>Saldo</h5>
              <p>Program lojalnościowy Dietly</p>
            </div>
          </div>
          <div className={styles['points']}>
            {numberWithSpaces(loyaltyProgramPointsGlobalBalance)}{' '}
            <span>pkt</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default YourLoyaltyPoints;
